import { render, staticRenderFns } from "./Suitability.vue?vue&type=template&id=27af2206&"
import script from "./Suitability.vue?vue&type=script&lang=js&"
export * from "./Suitability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/Suitability.vue"
export default component.exports